import { NavLink } from 'react-router'
import { colors, fontSize, spacing } from '../../styles/theme'

/**
 * Shared tab strip for the admin section. The admin pages previously existed only as separate
 * sidebar entries, two of which (Teams, Logs) had no sidebar entry at all — so Teams was
 * reachable only by typing the URL. A tab strip is what makes the section navigable as a section.
 */
const TABS = [
  { to: '/app/admin', label: 'Dashboard', end: true },
  { to: '/app/admin/users', label: 'Users' },
  { to: '/app/admin/teams', label: 'Teams' },
  { to: '/app/admin/analytics', label: 'Analytics' },
  { to: '/app/admin/billing', label: 'Billing' },
  { to: '/app/admin/notifications', label: 'Notifications' },
  { to: '/app/admin/logs', label: 'Logs' },
  { to: '/app/admin/jobs', label: 'Jobs' },
  { to: '/app/admin/compliance', label: 'Compliance' },
  { to: '/app/admin/governance', label: 'Governance' },
  { to: '/app/admin/auditors', label: 'Auditors' },
]

export default function AdminTabs() {
  return (
    <nav
      aria-label="Admin sections"
      // The strip scrolls sideways on narrow screens instead of widening the page (minWidth: 0 lets it
      // shrink inside the layout's flex column; nowrap keeps labels on one line).
      style={{
        display: 'flex', gap: spacing.xs, borderBottom: `1px solid ${colors.border}`, marginBottom: spacing.lg,
        overflowX: 'auto', overflowY: 'hidden', minWidth: 0, maxWidth: '100%', WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'thin',
      }}
    >
      {TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          style={({ isActive }: { isActive: boolean }) => ({
            padding: `${spacing.sm} ${spacing.md}`,
            fontSize: fontSize.sm,
            fontWeight: isActive ? 600 : 400,
            color: isActive ? colors.text : colors.textSecondary,
            textDecoration: 'none',
            borderBottom: `2px solid ${isActive ? colors.primary : 'transparent'}`,
            marginBottom: -1,
            whiteSpace: 'nowrap',
            flexShrink: 0,
          })}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  )
}
